import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbDataValueRenderer } from "abreact/data/AbDataValueRenderer";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import { AbDecimalInput } from "abreact/input/AbDecimalInput";
import * as React from "react";
export function AbDecimalDataValueInput(props) {
  const viewModel = AbFormHooks.useDataValueInputViewModel("ab-decimal-data-value-input", props);
  if (!viewModel) {
    return null;
  }
  const currentValue = viewModel.currentValue;
  return !viewModel.isEditing ? /*#__PURE__*/React.createElement(AbDataValueRenderer, _extends({}, viewModel.readOnlyProps, {
    subject: props.subject,
    accessor: props.accessor,
    currentValue: currentValue
  })) : /*#__PURE__*/React.createElement(AbDecimalInput, _extends({}, viewModel.inputProps, {
    value: currentValue ?? undefined,
    onChange: newValue => {
      viewModel?.changeValue(newValue ?? null);
    },
    decimalPlaces: props.decimalPlaces ?? props.accessor.constraints?.decimalPlaces,
    min: props.min ?? props.accessor.constraints?.min,
    max: props.max ?? props.accessor.constraints?.max
  }));
}
//# sourceMappingURL=AbDecimalDataValueInput.js.map
